/**
 * @generated SignedSource<<48fc1d120451c515aa024c5a3307b922>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProgramStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CoachProgramCard_program$data = {
  readonly clients: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"StackedClientsAvatars_clients">;
  }>;
  readonly createdAt: string | null | undefined;
  readonly createdAtFromNow: string | null | undefined;
  readonly description: string | null | undefined;
  readonly enrolledTotal: number;
  readonly id: string;
  readonly imageURL: string | null | undefined;
  readonly length: number;
  readonly name: string;
  readonly slug: string;
  readonly status: ProgramStatus;
  readonly " $fragmentSpreads": FragmentRefs<"CoachProgramMenu_program">;
  readonly " $fragmentType": "CoachProgramCard_program";
};
export type CoachProgramCard_program$key = {
  readonly " $data"?: CoachProgramCard_program$data;
  readonly " $fragmentSpreads": FragmentRefs<"CoachProgramCard_program">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CoachProgramCard_program",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CoachProgramMenu_program"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "length",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": "createdAtFromNow",
      "args": [
        {
          "kind": "Literal",
          "name": "format",
          "value": "fromNow"
        }
      ],
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": "createdAt(format:\"fromNow\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enrolledTotal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "clients",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StackedClientsAvatars_clients"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Program",
  "abstractKey": null
};

(node as any).hash = "4da1fd9259c151c68955021a100ffc92";

export default node;
